// svgWidth = width of the SVG
// const properties = require("svg-path-properties").svgPathProperties(path)
// const length = properties.getTotalLength()
// const percentage = (value / svgWidth) * length
// const point = properties.getPointAtLength(pourcentage)

import {toJS, autorun} from 'mobx';
import {observer,inject, Provider} from 'mobx-react'
import React from 'react';
import ReactDOM from 'react-dom';
import AppStore from './store.js';
import Slider from "react-slick";




/*
  Init stores and other tools
*/

window.store = new AppStore();

/*
  Views
*/

  function goBack(){

if(document.referrer.indexOf('siriobluevision') >= 0) {
    history.go(-1);
}
else {
    window.location.href = '/'; // this might just be '/' of your site
}

  }

const Head = observer(() =>

 <header>
    <a href={window.siteurl} className="logo" />
    <a onClick={ goBack } className="logo_back">←</a>
    <div className="nav">
      {store.maps.map((map)=>
        <div 
          key={map.id} 
          className={ "nav_item " + (store.map_current.id === map.id ? 'active' : 'inactive') }
          onClick={ ()=>store.mapSelect(map) }>
            <h3>{map.name}</h3>
            <span style={{backgroundImage:"url("+map.image+")"}}></span>  
          </div>
      )}
    </div> 
 </header>
);

const Loading = observer(() =>
 <div className="loader">
   <div className="loader_content">
    <div className="loader_logo" />
    <div className="loader_progress">Loading</div>
   </div>
 </div>
);

const Modal = observer(() =>
 <div className="modals" onClick={ ()=> store.tableClose() }>
   <div className="modal_close" />
   <div className="modal_content" style={{backgroundImage:"url("+store.table_current.image+")"}}>
   </div>
 </div>
);


var carouselSettings = {
  speed: 500,
  dots: false,
  arrows: true,
  autoPlay: false,
  infinite: false,
  slidesToShow: 4
}

const Aside_groups = observer(() =>
 <div className={"aside_groups ui_large " + (store.custom == true ? "aside_custom" : "aside_standard")}>
    {store.places_current.map( (group)=> {
      //console.log("group",group);
      return(
        <div key={group.subtype} onClick={ ()=> store.groupSelect(group) } className={store.group_current && store.group_current.name == group.name ? "aside_icon active" : "aside_icon"}>
          <i className={"icon_"+group.subtype} />
          <h3>{group.name}</h3>  
          <br />
          {/* <h3>test-stampa-react</h3>  */}
        </div>
      )
    })}
 </div>
);

const Aside_groups_mobile = observer(() =>
 <div className={"aside_groups ui_small " + (store.custom == true ? "aside_custom" : "aside_standard")}>
    <Slider {...carouselSettings}>
      {store.places_current.map( (group)=> {
        return(
          <div key={group.subtype} onClick={ ()=> store.groupSelect(group) } className={store.group_current && store.group_current.name == group.name ? "aside_icon active" : "aside_icon"}>
            <i className={"icon_"+group.subtype} />
            <h3>{group.name}</h3>     
          </div>
        )
      })}
    </Slider>
 </div>
);

const Aside_places = observer(() =>
 <div className="aside_places">
    <div className="aside_places_back" onClick={ ()=>store.groupSelect(null) }>Torna al menu</div>

    { store.group_current !== null && 
      <div>

        <h2 className="aside_title">
          {store.group_current.name}
          <div className="aside_count">{store.items_current.length}</div>
        </h2>

        {store.items_current.map( (item,i) => {

        if(item.type && store.group_current.type === 'path'){
          var active = (store.place_current_stage && store.place_current_stage.id === item.id) ? "active" : "inactive";
          var external = item.map === store.map_current.id ?  "internal" : "external";
          return(
            <div 
              key={store.group_current.name + item.id} 
              className={"aside_list_item " + " " + external + " " + active}
              onClick={ ()=>store.placeSelect(item) }><span className="item_image" style={{backgroundImage:"url("+item.image+")"}}>{item.number}</span> {item.name}</div>
          )
        }

        else if(store.group_current.type === 'meta_tables'){
          var t = toJS(store.place_current_stage);
          var lower = item.name.replace(" ","_").toLowerCase();
          var active = (store.place_current_stage && store.place_current_stage[0].type && store.place_current_stage[0].type.toLowerCase()  === lower) ? "active" : "inactive";
          // var external = item.map === store.map_current.id ?  "internal" : "external";
          var external = 'internal';
          // var active = 'inactive';
          return(
            <div 
              key={store.group_current.name + item.name} 
              className={"aside_list_item " + " " + external + " " + active}
              onClick={ ()=>store.placeMetaSelect(item.group.items) }>{item.name}</div>
          )
        }

        else if(item.type && store.group_current.type === 'resource'){
          var active = (store.place_current_stage && store.place_current_stage.id === item.id) ? "active" : "inactive";
          var external = item.map === store.map_current.id ?  "internal" : "external";
          return(
            <div 
              key={store.group_current.name + item.id} 
              className={"aside_list_item " + " " + external}
              onClick={ ()=>store.placeSelect(item) }>{item.name}</div>
          )
        }

        })};
      </div>
    }

 </div>
);

const Marker = observer((props) =>
 <div 
  className="marker" 
  style={{top:props.y+"%",left:props.x+"%",transform: "translateX(-50%) translateY(-100%) scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}
  onClick={ ()=> store.placeSelect(props) } >
    <div className="marker_image" />
    <div className="marker_tooltip">{props.name}</div>
  </div>
);

const MarkerUser = observer((props) =>
 <div 
  className="marker" 
  style={{top:props.y+"%",left:props.x+"%",transform: "translateX(-50%) translateY(-100%) scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}>
  <div className="marker_user" />
</div>
);

const MarkerCustom = observer((props) =>
 <div 
  className="marker" 
  style={{top:props.y+"%",left:props.x+"%",transform: "translateX(-50%) translateY(-50%) scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}
  onClick={ ()=> store.placeSelect(props) } >
    <div 
      className="marker_custom"
      style={{backgroundImage:"url('"+props.image+"')"}} />
    <div className="marker_tooltip">{props.name}</div>
  </div>
);

const MarkerMulti = observer((props) =>
  <span>
    {props.y1 && 
      <div 
        className="marker" 
        style={{top:props.y1+"%",left:props.x1+"%",transform: "translateX(-50%) translateY(-100%) scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}>
        <div className="marker_image" />
      </div>
    }
    {props.x2 &&
      <div 
        className="marker" 
        style={{top:props.y2+"%",left:props.x2+"%",transform: "translateX(-50%) translateY(-100%) scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}>
        <div className="marker_image" />
      </div>
    }
    {props.x3 &&
      <div 
        className="marker" 
        style={{top:props.y3+"%",left:props.x3+"%",transform: "translateX(-50%) translateY(-100%) scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}>
        <div className="marker_image" />
      </div>
    }
    {props.x3 &&
      <div 
        className="marker" 
        style={{top:props.y4+"%",left:props.x4+"%",transform: "translateX(-50%) translateY(-100%) scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}>
        <div className="marker_image" />
      </div>
    }
  </span>
);

const MarkerPath = observer((props) =>
  <span>
    {props.y1 && 
      <div 
        className="marker_double" 
        style={{top:props.y1+"%",left:props.x1+"%",transform: "scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}>
        <div className="marker_image" />
      </div>
    }
    {props.x2 &&
      <div 
        className="marker_double" 
        style={{top:props.y2+"%",left:props.x2+"%",transform: "scale(" + (1/(store.map_zoom*store.map_scale)) +")"}}>
        <div className="marker_image" />
      </div>
    }
    {props.path && 
    <img
      src={props.path}
      className="marker_path"
      style={{top:(Math.min(props.y1,props.y2))+"%",left:(Math.min(props.x1,props.x2))+"%",width:(Math.abs(props.x2-props.x1))+"%",height:(Math.abs(props.y2-props.y1))+"%"}} /> }
  </span>
);

const Aside_detail = observer(() =>
 <div className="aside_detail ui_large">

   <div className="aside_places_back" onClick={ ()=> store.placeSelect(null) }>Torna alla lista</div>
   <img className="aside_image" src={store.place_current_aside && store.place_current_aside.banner} />
   <h2 className="aside_title">{store.place_current_aside && store.place_current_aside.name}</h2>
   {store.place_current_aside && store.place_current_aside.number &&
    <p className="aside_text">Sentiero: <span className="item_image" style={{backgroundImage:"url("+store.place_current_aside.image+")"}}>{store.place_current_aside.number}</span></p>
   }
   {store.place_current_aside && store.place_current_aside.grade && store.place_current_aside.grade != "Nascondi" &&
    <p className="aside_text">Grado di difficoltà: <b>{store.place_current_aside.grade}</b></p>
   }
   {store.place_current_aside && store.place_current_aside.time &&
    <p className="aside_text">Tempo di percorrenza: <b>{store.place_current_aside.time}</b></p>
   }
   {store.place_current_aside && store.place_current_aside.text &&
      <p className="aside_text">
       {store.place_current_aside && store.place_current_aside.number &&
        <label className="aside_subtitle">Descrizione:</label>
       }
       <span>{store.place_current_aside.text}</span>
     </p>
   }
   {store.place_current_aside && store.place_current_aside.web && 
      <a
        className="aside_button"
        target="_blank" 
        href={store.place_current_aside.web}>Vai al sito</a>
    }
   {store.place_current_aside && store.place_current_aside.website && <a className="aside_button" href={store.place_current_aside.website} target="_blank">Vai al sito</a>}
 </div>
);


const Aside_detail_mobile = observer(() =>
 <div className="aside_detail ui_small">

    <div className="content_info">Scorri per leggere</div>
   <div className="content_close" onClick={ ()=> store.placeSelect(null) }></div>
   <div className="aside_places_back" onClick={ ()=> store.placeSelect(null) }>Torna alla lista</div>
   <img className="aside_image" src={store.place_current_aside && store.place_current_aside.banner} />
   <h2 className="aside_title">{store.place_current_aside && store.place_current_aside.name}</h2>
   {store.place_current_aside && store.place_current_aside.number &&
    <p className="aside_text">Sentiero: <span className="item_image" style={{backgroundImage:"url("+store.place_current_aside.image+")"}}>{store.place_current_aside.number}</span></p>
   }
   {store.place_current_aside && store.place_current_aside.grade &&
    <p className="aside_text">Grado di difficoltà: <b>{store.place_current_aside.grade}</b></p>
   }
   {store.place_current_aside && store.place_current_aside.time &&
    <p className="aside_text">Tempo di percorrenza: <b>{store.place_current_aside.time}</b></p>
   }
   {store.place_current_aside && store.place_current_aside.text &&
      <p className="aside_text">
       {store.place_current_aside && store.place_current_aside.number &&
        <label className="aside_subtitle">Descrizione:</label>
       }
       <span>{store.place_current_aside.text}</span>
     </p>
   }
   {store.place_current_aside && store.place_current_aside.web && 
      <a
        className="aside_button"
        target="_blank" 
        href={store.place_current_aside.web}>Vai al sito</a>
    }
   {store.place_current_aside && store.place_current_aside.website && <a className="aside_button" href={store.place_current_aside.website} target="_blank">Vai al sito</a>}
 </div>
);

const Stage = observer(React.createClass({


  initSvgPathListeners() {
    const svgPaths = document.querySelectorAll(".svg-layer path");
  
    svgPaths.forEach((path) => {
      path.addEventListener("click", (e) => {
        console.log('click');
        const isActive = path.getAttribute("data-active") === "true";
  
        if (isActive) {
          // Mostra tutti
          svgPaths.forEach((p) => {
            p.style.display = "inline";
            p.removeAttribute("data-active");
          });
        } else {
          // Nascondi tutti tranne quello cliccato
          svgPaths.forEach((p) => {
            if (p !== path) p.style.display = "none";
            else {
              p.setAttribute("data-active", "true");
            }
          });
        }
      });
    });
  },

  initSvgPathClickHandler() {
    const svgLayer = document.querySelector(".svg-layer");
    if (!svgLayer) return;
  
    if (this.svgClickBound) return;
    this.svgClickBound = true;
  
    svgLayer.addEventListener("click", (e) => {
      const clickedPath = e.target.closest("path");
      const allPaths = svgLayer.querySelectorAll("path");
      const anyIsFiltered = [...allPaths].some((p) => p.classList.contains("only-visible"));
  
      if (clickedPath && !anyIsFiltered) {
        // Primo click su un path → mostra solo lui
        allPaths.forEach((p) => p.style.display = "none");
        clickedPath.style.display = "inline";
        clickedPath.classList.add("only-visible");
      } else {
        // Qualsiasi altro click → ripristina tutti
        allPaths.forEach((p) => {
          p.style.display = "inline";
          p.classList.remove("only-visible");
        });
      }
    });
  },
  
  

  componentDidMount(){
    console.log("compnnent"); 
    var content = this.refs.content;
    var wrap = this.refs.content_wrap;
    store.mapEventsInit(content,wrap);
    console.log(content.clientHeight,content.clientWidth);
      

    // set reference height for default zoom
    setInterval(()=>{
      store.contentSizeSet(content.clientHeight,content.clientWidth);
      
    },1000);
    
    // window.onresize = (event)=> {
    //   setTimeout(()=>{
    //     store.contentSizeSet(content.clientHeight,content.clientWidth);
    //   });
    // };

  },

  componentDidUpdate() {
    if (store.map_current && store.map_current.svg_layer) {
      setTimeout(() => {
        this.initSvgPathClickHandler();
      }, 200);
    }
  },

  render() {

    var style = {
      transform: "translate("+store.map_transform_x+"px,"+store.map_transform_y+"px) " + "scale("+store.map_scale*store.map_zoom+")",
      WebkitTransform: "translate("+store.map_transform_x+"px,"+store.map_transform_y+"px) " + "scale("+store.map_scale*store.map_zoom+")",
      MozTransform: "translate("+store.map_transform_x+"px,"+store.map_transform_y+"px) " + "scale("+store.map_scale*store.map_zoom+")"
    }

    return (
      <div className="content" id="content" ref="content">

        <div className="content_controls">
          <div className="content_plus" onClick={ ()=>store.mapZoomIn() } />
          <div className="content_minus" onClick={ ()=>store.mapZoomOut() } />
        </div>

        { store.map_user_lat && store.map_user_lat && <a target="_blank" href={"https://www.google.com/maps/?q="+store.map_user_lat+","+store.map_user_lng} className="external_position">La tua posizione →</a> }

        <div className={"content_wrap " + (store.map_animated === true ? "active" : "inactive")} ref="content_wrap" style={style}>
          {store.map_current && store.map_current.svg_layer && (
            <div
              className="svg-layer"
              ref={(el) => { store.svgLayerEl = el }}
              dangerouslySetInnerHTML={{ __html: store.map_current.svg_layer }}
            />
          )}
          {store.map_markers.map( (marker,i)=>{

            if(marker && store.map_current.id === marker.map){

              if(marker.grouptype === 'path'){
                return(
                   <MarkerMulti key={marker.id} {...marker}/>
                ) 
              }
              else if(marker.grouptype === 'resource'){
                return(
                  <Marker key={marker.id} {...marker}/>
                )               
              }
              else if(marker.grouptype === 'tables'){
                return(
                  <MarkerCustom key={marker.id + "_" + i} {...marker}/>
                )               
              }
              else if(marker.grouptype === 'table'){
                return(
                  <img 
                    key={marker.id}
                    className="stage_overlay"
                    src={marker.back}/>
                )               
              }

            }
          })}
          <img 
            className="stage_map"
            src={store.map_current && store.map_current.image} />

        </div>
        
      </div>
    )
  }

}));


/*
  Main app component
*/

const App = observer(() =>

  <div>

    {store.loading === true && <Loading />}

    <Head />

    <div className={"body " + (store.group_current === null ? "inactive" : "active active_group") + (store.map_markers.length > 0 ? " active_place" : "") + (    (store.place_current_stage && (store.place_current_stage.grouptype == 'path' || store.place_current_stage.grouptype == 'resource'))  ? ' aside_info_active' : "" )}>

      <div className="aside">
        <div className="aside_menu">
          {store.place_current_aside !== null && <Aside_detail />}
          {store.place_current_aside === null && store.group_current !== null && <Aside_places/> }
          <Aside_groups />
          <Aside_groups_mobile />
        </div>
      </div>

      <Stage />      
      <Aside_detail_mobile />

    </div> 

  </div>  

);




/*
  Load views
*/
ReactDOM.render(
    <App />
, document.getElementById('app') );


/*
  External events
*/


function success(pos) {
  // console.log("position",pos);
  store.map_user_lat = pos.coords.latitude;
  store.map_user_lng = pos.coords.longitude;
}

function error(msg) {
  console.log(msg);
}

if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(success, error);
    navigator.geolocation.watchPosition(success, error);
  }
}

// if ("geolocation" in navigator) {


//   navigator.geolocation.watchPosition(
//     (pos) => { 
//       console.log("position");
//       store.map_user_lat = pos.coords.latitude;
//       store.map_user_lng = pos.coords.longitude;
//     },
//     (err) => {
//       // console.log("err",err);
//     },
//   )

//   navigator.geolocation.getCurrentPosition(
//     (pos) => { 
//       store.map_user_lat = pos.coords.latitude;
//       store.map_user_lng = pos.coords.longitude;
//     },  
//     (err) => {
//       // console.log("err",err);
//     },
//     {
//       enableHighAccuracy: false,
//       timeout: 100000,
//       maximumAge: 0
//     }
//   )

//   setInterval(()=>{

//     navigator.geolocation.getCurrentPosition(
//       (pos) => { 
//         store.map_user_lat = pos.coords.latitude;
//         store.map_user_lng = pos.coords.longitude;
//       },
//       (err) => {
//         // console.log("err",err);
//       },
//       {
//         enableHighAccuracy: false,
//         timeout: 100000,
//         maximumAge: 0
//       }
//     )

//   },20500);


// }




// WEBPACK FOOTER //
// ./src/main.jsx